import {
  ArrowFirstIcon,
  ArrowLastIcon,
  ArrowLeftSmallIcon,
  ArrowRightSmallIcon,
} from "@8x8/oxygen-icon";
import React, { memo, useMemo } from "react";
import {
  ButtonsContainer,
  HorizontalMarginInput,
  MarginLeftSelect,
  MarginLeftSpan,
  PageSelectWrapper,
} from "@/react/components/table/components/styled";
import { Button } from "@/react/styled";

const TablePagination = ({
  hasNextPage,
  hasPreviousPage,
  nextPage,
  pageCount,
  pageIndex,
  pageSize,
  previousPage,
  setPageIndex,
  setPageSize,
  totalRows,
  pageSizes,
}) => {
  const selectOptions = useMemo(
    () =>
      pageSizes.map((value) => ({
        value,
        label: `Show ${value}`,
      })),
    [pageSizes]
  );
  return (
    <>
      <small>
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} / {pageCount}
          </strong>{" "}
          - {totalRows} {totalRows === 1 ? "row" : "rows"}
        </span>
        <MarginLeftSpan>|</MarginLeftSpan>
        <span>Go to: </span>
      </small>
      <HorizontalMarginInput
        type="number"
        size="small"
        value={pageIndex + 1}
        onChange={(e) => {
          const page = e.target.value ? Number(e.target.value) - 1 : 0;
          setPageIndex(page);
        }}
      />
      <PageSelectWrapper>
        <MarginLeftSelect
          value={{ value: pageSize, label: `Show ${pageSize}` }}
          size="small"
          isClearable={false}
          onChange={({ value }) => {
            setPageSize(Number(value));
          }}
          options={selectOptions}
          menuPlacement="top"
        />
      </PageSelectWrapper>
      <ButtonsContainer>
        <Button
          size="small"
          variant="tertiary"
          onClick={() => setPageIndex(0)}
          isDisabled={!hasPreviousPage}
        >
          <ArrowFirstIcon size={18} />
        </Button>
        <Button
          size="small"
          variant="tertiary"
          onClick={previousPage}
          isDisabled={!hasPreviousPage}
        >
          <ArrowLeftSmallIcon size={18} />
        </Button>
        <Button
          size="small"
          variant="tertiary"
          onClick={nextPage}
          isDisabled={!hasNextPage}
        >
          <ArrowRightSmallIcon size={18} />
        </Button>
        <Button
          size="small"
          variant="tertiary"
          onClick={() => setPageIndex(pageCount - 1)}
          isDisabled={!hasNextPage}
        >
          <ArrowLastIcon size={18} />
        </Button>
      </ButtonsContainer>
    </>
  );
};

export default memo(TablePagination);
